/**
 * GiftCardLedgerRow — one entry in the gift-card ledger (BON-223): icon,
 * label/code/date/ref/reason, and the signed amount with its running
 * balance.
 */
import { GiftCardLedgerRowAmount } from './GiftCardLedgerRowAmount';
import { GiftCardLedgerRowIcon } from './GiftCardLedgerRowIcon';
import { GiftCardLedgerRowMeta } from './GiftCardLedgerRowMeta';
import { txnMeta } from './giftCardsModel';
import type { GiftCardLedgerEntry } from './giftCardTypes';

export function GiftCardLedgerRow({
  entry,
  balanceCents,
  currency,
  last,
}: {
  entry: GiftCardLedgerEntry;
  balanceCents: number;
  currency: string;
  last: boolean;
}) {
  const meta = txnMeta(entry.type);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 16px',
        borderBottom: last ? undefined : '1px solid var(--nb-border)',
      }}
    >
      <GiftCardLedgerRowIcon icon={meta.icon} type={entry.type} credit={entry.amountCents > 0} />
      <GiftCardLedgerRowMeta entry={entry} meta={meta} />
      <GiftCardLedgerRowAmount
        amountCents={entry.amountCents}
        balanceCents={balanceCents}
        currency={currency}
      />
    </div>
  );
}
